module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/covid19/pc/relation_link_pregnant_down-5d7e0b74a69932ba58ef7f422dc2da87.png";